"use strict";
/// <reference path="irep.js"/> 
IREP.brazilcampaign = (function () {
     

    function init() {
         
         
    }
    return {
        init: init
    };
})();